import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminInbox from "@/pages/AdminInbox";

function App() {
  return (
    <I18nProvider>
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/legal/:doc" element={<Legal />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/inbox" element={<AdminInbox />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </MotionConfig>
    </I18nProvider>
  );
}

export default App;
